var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatisfiedClientsSectionImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_414",
    "data-name": "Group 414",
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 530.113,
    viewBox: "0 0 468 530.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M667.238,576.871a5.8,5.8,0,0,0,8.116-7.262l.321-1.6a15.574,15.574,0,0,1,26.181,12.178c-.718,17.472.145,36.326-11.468,50.411,53-43.312,77.17-117.1,60.984-183.457-7.942-11.067-11.647-25.77-8.086-39.093,4.47,4.347,13.182,3.179,11.851-4.346-.714-2.974-1.453-5.939-2.168-8.913,30.528-11.913,38.5,33.48,2.336,51.961A185.847,185.847,0,0,1,760.1,485.21a78.145,78.145,0,0,1,19.83-30.758c8.667-7.8,20.126-12.391,30.787-17.626,12.973-6.387,27.37,6.275,22.262,19.793-8.636-1.1-14.746,9.217-6.91,14.764C812.3,494.5,785.913,509.192,759.1,509.425a186.583,186.583,0,0,1-24.354,74.787c17.13-26.047,50.28-18.548,76.478-19.658a9.026,9.026,0,0,1,8.492,14.176,52.146,52.146,0,0,0-10.323.42,7.879,7.879,0,0,0-2.885,14.559c-22.982,21.068-58.593,25.6-86.542,12.153a191.816,191.816,0,0,1-27.818,28.412l-41.552-19.807c.071-.533.164-1.073.25-1.6a52.3,52.3,0,0,0,11.824,4.8c-4.433-16.9-9.372-26.8,4.567-40.793Z",
    transform: "translate(-366.034 -184.392)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M591.283,536.973a5.8,5.8,0,0,1-10.255-3.664l-.9-1.357A15.574,15.574,0,0,0,560.475,553.1c7.255,15.911,13.568,33.7,29.636,42.362-65.425-20.12-115.639-79.337-125.68-146.9,3.181-13.246,1.067-28.26-7.258-39.255-2.5,5.712-11.009,7.917-12.615.445-.46-3.024-.894-6.049-1.355-9.073-32.766.483-23.026,45.528,17.436,49a185.855,185.855,0,0,0,10.066,37.424A78.146,78.146,0,0,0,440.739,466.1c-10.97-3.958-23.313-3.884-35.162-4.712-14.424-1.022-22.981,16.136-13.152,26.729,7.581-4.281,17.134,2.974,11.968,11.067,21.467,16.217,51.451,19.869,76.373,9.97a186.584,186.584,0,0,0,50.765,60.076c-25.689-17.662-53.562,1.788-78.244,10.642a9.026,9.026,0,0,0-2.518,16.332,52.131,52.131,0,0,1,9.719-3.505,7.879,7.879,0,0,1,8.164,12.4c29.231,10.843,63.92,1.6,84.733-21.388a191.82,191.82,0,0,0,36.48,15.82l31.011-34.017c-.267-.467-.557-.932-.835-1.386a52.3,52.3,0,0,1-9.142,8.9c-2.269-17.322-1.428-28.352-19.617-36.057Z",
    transform: "translate(-363.501 -184.468)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M601.018,391.123a5.8,5.8,0,0,0,2.688-10.553l-.624-1.5a15.574,15.574,0,0,1,28.523-4.487c9.146,14.9,20.374,30.075,18.587,48.243,19.851-65.507-1.224-140.232-51.661-186.3-12.764-4.759-24.037-14.9-28.509-27.944,6.134,1.117,12.716-4.711,7.415-10.215-2.251-2.071-4.518-4.12-6.769-6.191,18.7-26.91,50.626,6.328,30.91,41.832A185.861,185.861,0,0,1,627,263.257a78.146,78.146,0,0,1-.687-36.589c2.844-11.31,9.8-21.508,15.73-31.8,7.208-12.535,26.22-10.051,29.517,4.019-7.785,3.9-7.1,15.873,2.5,16.109,1.462,26.864-12.255,53.775-34.385,68.92a186.582,186.582,0,0,1,21.48,75.663c-.3-31.174,31.4-43.431,52.528-58.959a9.026,9.026,0,0,1,14.953,7.033,52.131,52.131,0,0,0-8.336,6.1,7.879,7.879,0,0,0,5.723,13.695c-7.332,30.3-34.369,53.918-65.066,58.34a191.809,191.809,0,0,1-7.252,39.1l-45.537,6.725c-.238-.482-.462-.983-.684-1.467a52.3,52.3,0,0,0,12.49-2.612c-13.1-11.557-22.721-17.019-18.952-36.41Z",
    transform: "translate(-365.256 -182.361)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M647.2,377.573c-20.732,0-31.976-2.533-35.9-7.941-3.465-4.771-1.142-11.067,1.548-18.356,1.933-5.239,4.124-11.178,4.124-17.055,0-28.586,14.494-43.08,43.08-43.08,14.223,0,29.494,7.555,40.85,20.211,10.324,11.505,15.467,25.275,14.111,37.778h0c-1.113,10.254-5.885,17-15.021,21.223l-.534.247-.152-.569a24.3,24.3,0,0,0-3.936-8.161,27.926,27.926,0,0,1-2.847,11.065l-.1.2-.211.06c-10.339,2.945-22.61,3.743-32.145,4.108Q653.107,377.571,647.2,377.573Z",
    transform: "translate(-365.638 -183.411)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M651.894,418.219a15.515,15.515,0,0,0-24.156-7.294l-68.192,40.77-21.338-52.066a15.149,15.149,0,1,0-16.738,6.017c1.315,15.014,8.624,82.121,34.051,79.681,21.373-2.05,74.45-37.4,90.936-49.655A15.516,15.516,0,0,0,651.894,418.219Z",
    transform: "translate(-364.682 -184.229)",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M703.917,716.018H644.565l-9.953-49.21-3.229,49.21H576.251a1124.59,1124.59,0,0,1,6.031-115.7l.684-2.327,1.08-3.724.683-2.337,11.409-39.178.9-3.11h68.7a100.567,100.567,0,0,1,10.9,12.043c1.119,1.426,2.288,2.971,3.486,4.635.832,1.179,1.694,2.417,2.555,3.714a124.782,124.782,0,0,1,16.935,37.237v.01q.906,3.4,1.6,6.962v.01c.416,2.109.782,4.249,1.07,6.437.218,1.594.406,3.209.545,4.843a111.02,111.02,0,0,1-.862,27.155Z",
    transform: "translate(-365.317 -185.906)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 7.484,
    cy: 5.206,
    rx: 7.484,
    ry: 5.206,
    transform: "translate(13.182 73.13) rotate(-21.162)",
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 7.484,
    cy: 5.206,
    rx: 7.484,
    ry: 5.206,
    transform: "translate(61.712 66.905) rotate(-21.162)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 7.484,
    cy: 5.206,
    rx: 7.484,
    ry: 5.206,
    transform: "translate(8.973 114.535) rotate(-21.162)",
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 3.29,
    cy: 4.73,
    rx: 3.29,
    ry: 4.73,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 0.288, 131.359)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 3.29,
    cy: 4.73,
    rx: 3.29,
    ry: 4.73,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 0, 162.28)",
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 3.29,
    cy: 4.73,
    rx: 3.29,
    ry: 4.73,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 42.594, 98.235)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 3.29,
    cy: 4.73,
    rx: 3.29,
    ry: 4.73,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 17.034, 92.028)",
    fill: "#ff6584"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 3.29,
    cy: 4.73,
    rx: 3.29,
    ry: 4.73,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 44.125, 63.555)",
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(47.336 280.276) rotate(-49.596)",
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(18.753 240.564) rotate(-49.596)",
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(85.749 264.262) rotate(-49.596)",
    fill: "#ff6584"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 111.692, 268.677)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 139.021, 254.208)",
    fill: "#3f3d56"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 62.422, 247.248)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 69.133, 272.68)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 31.196, 262.413)",
    fill: "#3f3d56"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(242.843 20.182) rotate(-26.188)",
    fill: "#e6e6e6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(253.298 67.981) rotate(-26.188)",
    fill: "#3f3d56"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 5.206,
    cy: 7.484,
    rx: 5.206,
    ry: 7.484,
    transform: "translate(201.23 19.618) rotate(-26.188)",
    fill: "#ff6584"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "translate(184.073 10.829) rotate(-18.343)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "translate(153.245 13.25) rotate(-18.343)",
    fill: "#3f3d56"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "translate(220.776 50.069) rotate(-18.343)",
    fill: "#e6e6e6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "translate(224.719 24.064) rotate(-18.343)",
    fill: "#ff6584"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 4.73,
    cy: 3.29,
    rx: 4.73,
    ry: 3.29,
    transform: "translate(255.456 48.557) rotate(-18.343)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M637.009,386.434l32.7-1.684,15.187,24s28.575,4.777,26.594,38.449-34.767,63.219-34.767,63.219l1.4,17.535-2.434,6.955L676,538.81l3.321,4.136.342,4.277-2.942,6.767,4,6.48-84.114-8.149-3.076-11.2,4.487-6.017-2.506-7.848,3.768-7.548,1.965-23.977s-21.495-32.293,3.181-56.615l9.9-16.836,11.081-13.52Z",
    transform: "translate(-365.474 -184.314)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 34.647,
    cy: 34.647,
    r: 34.647,
    transform: "translate(253.144 126.051)",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M648.757,342.094q-4.478,0-8.952-.252l-.533-.03.07-.529a24.266,24.266,0,0,0-.726-9.876,27.931,27.931,0,0,1-6.807,9.613l-.165.151-.222-.024a171,171,0,0,1-24.017-4.38l-.3-.077-.06-.306a45.338,45.338,0,0,1-.911-8.792c0-9.226,3.345-16.991,9.419-21.865,6.611-5.305,16.088-6.937,26.694-4.6h33.915a14.079,14.079,0,0,1,14.063,14.063v21.477l-.37.1a162.232,162.232,0,0,1-41.095,5.328Z",
    transform: "translate(-365.605 -183.497)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M410.419,303.081a6.1,6.1,0,0,0-3.641,7.817l36.587,100.391a6.1,6.1,0,0,0,7.817,3.641l142-51.751a6.1,6.1,0,0,0,3.641-7.817l-36.586-100.39a6.1,6.1,0,0,0-7.816-3.641Z",
    transform: "translate(-363.677 -183.023)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M540.381,376.953,453.463,408.63a6.57,6.57,0,0,1-8.413-3.919l-33.184-91.053a6.57,6.57,0,0,1,3.919-8.413l133.975-48.826a6.57,6.57,0,0,1,8.413,3.919l16.034,44a56.712,56.712,0,0,1-33.826,72.619Z",
    transform: "translate(-363.726 -183.072)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M478.256,311.673,457.6,319.2a2.1,2.1,0,1,1-1.438-3.945l20.655-7.527a2.1,2.1,0,1,1,1.438,3.945Z",
    transform: "translate(-364.144 -183.57)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M527.526,302.78l-66.956,24.4a2.1,2.1,0,0,1-1.438-3.945l66.956-24.4a2.1,2.1,0,0,1,1.438,3.945Z",
    transform: "translate(-364.173 -183.484)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M530.934,312.131l-66.955,24.4a2.1,2.1,0,1,1-1.438-3.945l66.956-24.4a2.1,2.1,0,1,1,1.438,3.945Z",
    transform: "translate(-364.206 -183.574)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M534.342,321.481l-66.956,24.4a2.1,2.1,0,1,1-1.438-3.945l66.956-24.4a2.1,2.1,0,0,1,1.438,3.945Z",
    transform: "translate(-364.238 -183.664)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M537.749,330.832l-66.955,24.4a2.1,2.1,0,0,1-1.438-3.945l66.956-24.4a2.1,2.1,0,0,1,1.438,3.945Z",
    transform: "translate(-364.271 -183.754)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M752.306,355.931l-36.659,87.725a15.346,15.346,0,0,1-19.877,8.275h0a15.346,15.346,0,0,1-8.176-20.716l40.873-89.957L751,285.55a13.392,13.392,0,1,1,17.122,1.5Z",
    transform: "translate(-366.377 -183.136)",
    fill: "#ffb6b6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfiedClientsSectionImage);
export default __webpack_public_path__ + "static/media/satisfied-clients-section-image.81831fe1c7e726db13f892efc5d16069.svg";
export { ForwardRef as ReactComponent };